exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-select .dropdown-toggle  {\n    height:50px;\n}\n.v-select.open .selected-tag {\n    margin-top:12px;\n}\n.v-select .selected-tag {\n    color: #7a7876 !important;\n}\n.v-select .dropdown-toggle .vs__actions .clear {\n    display: none;\n}\n.v-select .dropdown-toggle {\n    border-radius:0px;\n}\n.v-select {\n    border: 1px solid #d5d5d5;\n}\n.v-select .open-indicator {\n    width:20px;\n}\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-491f4853","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/product/specificeren.vue
// module id = 3D0Q
// module chunks = 1